import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const mckessonApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMckessonVendorDetail: builder.mutation({
      query: () => ({
        url: `/mckesson/getvendordetail`,
        method: "GET",
      }),
    }),
    getMckessonShippingLocations: builder.mutation({
      query: () => ({
        url: `/mckesson/getshippinglocations`,
        method: "GET",
      }),
    }),
    getMckessonApis: builder.mutation({
      query: () => ({
        url: `/mckesson/getapis`,
        method: "GET",
      }),
    }),
    postMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postapi`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putapi`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/deleteapi?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    postMckessonVendorDetail: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postvendordetail`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonVendorDetail: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putvendordetail`,
        method: "PUT",
        body: data,
      }),
    }),
    postMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postshippinglocation`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putshippinglocation`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/deleteshippinglocation?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    getMckessonEdiFileList: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getmckessonedifilelist?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonOrderFiles: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/files?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonEdiItemList: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getmckessoneditemlist?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonOrderDataItems: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/dataitems?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    fetchMckessonOrderItem: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/fetch?${getFilters(data)}`,
        method: "POST",
        body: data,
      }),
    }),
    markMckessonOrderProcessed: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/markprocessed`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetMckessonVendorDetailMutation,
  useGetMckessonShippingLocationsMutation,
  useGetMckessonApisMutation,
  usePostMckessonApiMutation,
  usePutMckessonApiMutation,
  useDeleteMckessonApiMutation,
  usePostMckessonVendorDetailMutation,
  usePutMckessonVendorDetailMutation,
  usePostMckessonShippingLocationMutation,
  usePutMckessonShippingLocationMutation,
  useDeleteMckessonShippingLocationMutation,
  useGetMckessonEdiFileListMutation,
  useGetMckessonEdiItemListMutation,
  useGetMckessonOrderFilesMutation,
  useGetMckessonOrderDataItemsMutation,
  useFetchMckessonOrderItemMutation,
  useMarkMckessonOrderProcessedMutation,
} = mckessonApiSlice;
